import { useRef, useState, useEffect } from 'react';
import { Text, Tooltip } from '@mantine/core';

function TruncatedTextHandler({ text, maxWidth=200, className, marginTop='0px', onClick, alternateTooltipText=null, truncate=true, alwaysEnableTooltip=false, removePointerCursor=false, disableTooltip=false, maxWidthPercentage=null, tooltipWidth=null, styleText={} }) {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip gutter={12} zIndex={99999} label={alternateTooltipText ? alternateTooltipText : text} styles={{body: {border: '1px solid rgb(247, 247, 250)'}}} style={{marginTop: marginTop, cursor: removePointerCursor ? 'default' : 'pointer'}} disabled={disableTooltip ? disableTooltip : alwaysEnableTooltip ? false : !isTruncated} wrapLines={true} width={tooltipWidth || 'auto'} transitionDuration={200}>
      <Text
        ref={textRef}
        style={{...{
          maxWidth: truncate ? (maxWidthPercentage || `${maxWidth}px`) : 'auto',
          overflow: 'clip',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        ...styleText}}
        className={className}
        onClick={onClick}
      >
        {text}
      </Text>
    </Tooltip>
  );
}

export default TruncatedTextHandler;
